import client from "api/client";
import Cookies from "js-cookie";

export interface SignInParams {
  login: string
  password: string
}

interface SignUpParams {
  userName: string
  email: string
  password: string
  passwordConfirmation: string
}

export const signIn = (params: SignInParams) => {
  return client.post("api/v1/auth/sign_in", params)
}

export const signUp = (params: SignUpParams) => {
  return client.post("api/v1/auth", params)
}

export const signOut = () => {
  return client.delete("api/v1/auth/sign_out", {
    headers: {
      "access-token": Cookies.get("_access_token"),
      client: Cookies.get("_client"),
      uid: Cookies.get("_uid"),
    },
  })
}

// ログインユーザーの取得
export const getCurrentUser = () => {
  if (!Cookies.get("_access_token") || !Cookies.get("_client") || !Cookies.get("_uid")) return;

  return client.get("api/v1/auth/sessions", {
    headers: {
      "access-token": Cookies.get("_access_token"),
      client: Cookies.get("_client"),
      uid: Cookies.get("_uid"),
    },
  })
}

// パスワード認証
export const verifyPassword = async (signInParams: SignInParams): Promise<boolean> => {
  try {
    const response = await client.post('api/v1/auth/sign_in', signInParams);
    return response.status === 200;
  } catch (error) {
    console.error('パスワード認証エラー:', error);
    return false;
  }
};
